import { useState, useEffect } from 'react'
import { fetchUserAttributes } from 'aws-amplify/auth'

interface EmailVerificationStatus {
  isVerified: boolean
  email: string | null
  isLoading: boolean
  error: string | null
  checkVerificationStatus: () => Promise<void>
}

export const useEmailVerification = (): EmailVerificationStatus => {
  const [isVerified, setIsVerified] = useState(true)
  const [email, setEmail] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const checkVerificationStatus = async () => {
    try {
      setIsLoading(true)
      setError(null)

      const attributes = await fetchUserAttributes()
      const userEmail = attributes.email
      const emailVerified = attributes.email_verified === 'true'

      setEmail(userEmail || null)
      setIsVerified(emailVerified)
    } catch (err: unknown) {
      // If user is not authenticated, we don't need to check verification
      if (err instanceof Error && err.name === 'UserUnAuthenticatedException') {
        setIsVerified(true) // Don't prompt for unauthenticated users
        setEmail(null)
      } else {
        setError(err instanceof Error ? err.message : 'Failed to check email verification status')
      }
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    checkVerificationStatus()
  }, [])

  return {
    isVerified,
    email,
    isLoading,
    error,
    checkVerificationStatus,
  }
}
